function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavExpandRightMobile = function SvgNavExpandRightMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.3,
      strokeMiterlimit: 10
    },
    d: "m9.4 17.1 5.2-5.2-5.3-5.3"
  }));
};
export default SvgNavExpandRightMobile;